module.exports = __webpack_public_path__ + "img/cspace-applestore.679090a1.svg";